module.exports = __webpack_public_path__ + "static/media/COLA2018006.958491c4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018006.pdf
// module id = 2269
// module chunks = 1